import React from 'react';
import AppHeader from '../app-header/AppHeader';
import LeftNav from '../left-nav/LeftNav';
import { getLeftNavs } from '../utils/configuration';
import { getUserDetails } from '../utils/shared-data.service';
import './baseapp.scss';

function BaseApp(props) {
  props.history.listen((location, action) => {
    // location is an object like window.location
    if (location.pathname !== '/login') {
      let details = getUserDetails();
      if (
        !details ||
        (details instanceof Object &&
          Object.getOwnPropertyNames(details).length === 0)
      ) {
        props.history.push('/login');
      }
    }
  });

  return (
    <div className='dashboard-background'>
      <AppHeader {...props} />
      <div className='dashboard-content'>
        <LeftNav routes={getLeftNavs()} />
      </div>
    </div>
  );
}

export default BaseApp;
